import { DisplayPosition } from '@/type/display-position';
import { calculateTextExprValue, executeFunction, isArrayNotEmpty, makeButtons, uuid, } from '../../util/util';
import { getMixedSetterSnippet } from '@/common/manager/setter-snippet';
import { getJSExpressionPrototype } from '@/common/manager/common-style';
import { createButtonListSetters } from '@/common/manager/button';
import { ButtonPosition } from '@/type/button-position';
import { CnBox } from '@cainiaofe/cn-ui-m';
// import {createButtonListSetters} from "@/lowcode/common/manager/button";
// import {ButtonPosition} from "@/lowcode/common/manager/position/button-position";
const CnFormGrid = 'CnFormGrid';
const CnCard = {
    position: [DisplayPosition.formDialog, DisplayPosition.form],
    title: '卡片',
    componentName: 'CnCard',
    isFormContainer: true,
    allowParentList: ['root', 'CnFormStepItem', 'CnFormTabItem'],
    formItemBeforeHandler: (formItem, config) => {
        const { formItemConfig = {}, formProps = {}, state, _context, urlParams, formValue, formInstance, } = config || {};
        const { formStyle = {} } = formProps;
        const { cols, readOnly } = formStyle || {};
        if (formItem) {
            const { label, name, readOnly: formItemReadOnly, options = {}, } = formItemConfig;
            const { buttons = [], action } = options;
            const componentProps = formItem['x-component-props'];
            if (componentProps) {
                if (label && !componentProps.title) {
                    componentProps.title = label;
                }
                else if (componentProps.title) {
                    componentProps.title = calculateTextExprValue(componentProps.title, {
                        recordDataSource: formValue || {},
                        state,
                    });
                }
                if (componentProps.subTitle) {
                    componentProps.subTitle = calculateTextExprValue(componentProps.subTitle, {
                        recordDataSource: formValue || {},
                        state,
                    });
                }
                if (isArrayNotEmpty(buttons)) {
                    const subAction = makeButtons({
                        buttons: buttons.map((item) => {
                            let realChildren = item?.children;
                            if (typeof item?.children === 'function') {
                                realChildren = executeFunction(item.children, formValue, state);
                            }
                            return {
                                ...item,
                                // size:'small',
                                type: 'primary',
                                text: true,
                                position: ButtonPosition.subCardAction,
                                children: realChildren,
                            };
                        }),
                        _context,
                        state,
                        urlParamsDataSource: urlParams,
                        recordDataSource: formValue,
                        formInstance,
                    });
                    if (isArrayNotEmpty(subAction)) {
                        componentProps.subAction = (React.createElement(CnBox, { spacing: 8, direction: 'row' }, subAction));
                        delete componentProps.buttons;
                    }
                }
                if (isArrayNotEmpty(action)) {
                    const Action = makeButtons({
                        buttons: action.map((item) => {
                            let realChildren = item?.children;
                            if (typeof item?.children === 'function') {
                                realChildren = executeFunction(item.children, formValue, state);
                            }
                            return {
                                ...item,
                                // size:'small',
                                type: 'primary',
                                text: true,
                                position: ButtonPosition.cardAction,
                                children: realChildren,
                            };
                        }),
                        _context,
                        state,
                        urlParamsDataSource: urlParams,
                        recordDataSource: formValue,
                        formInstance,
                    });
                    if (isArrayNotEmpty(Action)) {
                        componentProps.action = (React.createElement(CnBox, { spacing: 8, direction: 'row' }, Action));
                    }
                    else {
                        delete componentProps.action;
                    }
                }
            }
            // if(formItemReadOnly === undefined) {
            //   formItem.readOnly = readOnly;
            // }else if(isBoolean(formItemReadOnly)) {
            //   formItem.readOnly = formItemReadOnly;
            // }
            delete formItem['x-decorator'];
            formItem.properties = {};
            formItem.title = '';
            formItem.type = 'void';
            const { cols: cardCols } = componentProps;
            const formGridProps = {};
            if (cardCols) {
                formGridProps.cols = cardCols;
            }
            else {
                formGridProps.cols = cols;
            }
            formItem.properties = {
                [`${name}_${CnFormGrid}`]: {
                    type: 'void',
                    'x-component': CnFormGrid,
                    'x-component-props': formGridProps,
                    properties: {},
                },
            };
        }
    },
    getDefaultProps: () => {
        return {
            foldable: true,
        };
    },
    getFormItemDefaultProps: () => {
        return {
            label: '',
            name: `card_${uuid()}`,
        };
    },
    getPrototypeList: () => {
        return [
            {
                name: 'title',
                title: '卡片外标题',
                display: 'inline',
                setter: getMixedSetterSnippet({
                    setters: [
                        {
                            componentName: 'CnI18nSetter',
                            title: '多语言Setter',
                        },
                        getJSExpressionPrototype({
                            type: 'formRequest',
                        }),
                    ],
                }),
            },
            {
                name: 'desc',
                title: '外标题说明',
                display: 'inline',
                setter: 'CnI18nSetter',
            },
            {
                name: 'subTitle',
                title: '卡片内标题',
                display: 'inline',
                setter: getMixedSetterSnippet({
                    setters: [
                        {
                            componentName: 'CnI18nSetter',
                            title: '多语言Setter',
                        },
                        getJSExpressionPrototype({
                            type: 'formRequest',
                        }),
                    ],
                }),
            },
            {
                name: 'subDesc',
                title: '内标题说明',
                display: 'inline',
                setter: 'CnI18nSetter',
            },
            // {
            //   name: 'foldable',
            //   title: '支持折叠',
            //   display: 'inline',
            //   setter: 'BoolSetter',
            // },
            // {
            //   name: 'icon',
            //   title: '左侧图标',
            //   display: 'inline',
            //   setter: 'StringSetter',
            // },
            {
                name: 'action',
                title: '外标题右侧按钮',
                display: 'accordion',
                collapsed: true,
                extraProps: {
                    defaultCollapsed: true,
                },
                setter: createButtonListSetters({
                    position: ButtonPosition.cardAction,
                }),
            },
            {
                name: 'buttons',
                title: '内标题右侧按钮',
                display: 'accordion',
                collapsed: true,
                extraProps: {
                    defaultCollapsed: true,
                },
                setter: createButtonListSetters({
                    position: ButtonPosition.subCardAction,
                }),
            },
        ];
    },
};
export default CnCard;
